import { UIParagraphFormat } from '../../../config/formats';
import { MEmailBlock } from '../../mdl/m-template';
import { UICheckbox } from '../../ui/component/toggle';
import { $el } from '../../ui/elements';
import { $on } from '../../y/events';
import { $form } from '../../y/form';
import { EDBlockSpec, EDBlock } from '../block';
import { EDBlockContainer } from '../editor';
import { EDI18NInput } from '../input';
import { EDEmailEditor } from './editor';

const default_formats: UIParagraphFormat[] = ['email-text', 'email-info', 'email-title', 'email-heading'];

export const ed_email_text_block: EDBlockSpec<MEmailBlock, EDEmailEditor> = {
    key: 'text',
    editor_block: class extends EDBlock<EDEmailEditor> {
        constructor(container: EDBlockContainer<EDEmailEditor>) {
            const columns = new UICheckbox({ title: 'Columns' });

            const properties = $el.DIV('l-form', [columns]);

            const text = new EDI18NInput({ multiline: true, styleable: true, formats: default_formats, link_values: container.editor.link_values, default_format: 'email-text', fields: container.editor.fields }); // TODO: images

            super($form({ text, columns }), container, 'Text', properties);

            const block = $el.DIV('tl-email-text', text);

            this.ui_add(block);

            $on(columns, 'value', v => {
                block.classList.toggle('u-columns', !!v);
            });
        }
    },
};
